export enum RoutingGuideClassification {
  EXCLUDED = 'EXCLUDED',
  PREFERRED = 'PREFERRED',
  STANDARD = 'STANDARD',
}
